<script>
export default {
}
</script>

<template>
    <div class="alertMsg">Вы разлогинены. Пожалуйста, <a href="/">авторизуйтесь заново</a>.</div>
</template>

<style>
.alertMsg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #dc3545;
    text-align: center;
    font-size: larger;
    font-weight: bold;
    color: white;
    padding-top: 10px;
    padding-bottom: 10px;
}

.alertMsg a, .alertMsg a:hover {
    color: white;
    text-decoration: underline;
}
</style>
